import React from 'react';
import { Sidebar } from '@insurancemenu/imenu-components-lib';
import { FileDashboardContent, FileDashboardType } from 'pages/FilesTrackingPage';
import clsx from 'clsx';
import { createStyles } from './styles';

export interface FileDashboardSidebarProps {
  activeDashboardType: FileDashboardType;
  setDashboardType: (e: React.SyntheticEvent<HTMLLIElement>) => void;
}

const FileDashboardSidebar = ({ activeDashboardType, setDashboardType }: FileDashboardSidebarProps): JSX.Element => {
  const classes = createStyles();

  const dashboardItems = Object.keys(FileDashboardContent).map((dashboardType) => {
    const isDashboardTypeActive = activeDashboardType === (dashboardType as FileDashboardType);

    return (
      <li
        key={dashboardType}
        role="menuitem"
        tabIndex={0}
        onKeyDown={setDashboardType}
        onClick={setDashboardType}
        data-dashboard-type={dashboardType}
        className={clsx(classes.dashboardItem, isDashboardTypeActive ? classes.dashboardActiveItem : '')}
      >
        {FileDashboardContent[dashboardType as FileDashboardType].icon}
        <span>{FileDashboardContent[dashboardType as FileDashboardType].title}</span>
      </li>
    );
  });

  return (
    <Sidebar wrapperClassName={classes.fileDashboardSidebar} className={classes.fileDashboardInnerSidebar}>
      <p className={classes.sidebarTitle}>Dashboards</p>
      <ul className={classes.dashboardsList}>{dashboardItems} </ul>
    </Sidebar>
  );
};

export default FileDashboardSidebar;
